// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"265bac4d","230":"9ef6b669","457":"b5d4a089"}[chunkId] + ".chunk.js";
};